import {
  IconTicket,
  IconListSearch,
  IconListDetails,
  IconMessageCircle,
} from '@tabler/icons-react';
import { themeColors } from '../../../styles/globalStyleVars';

export const commonItems = [
  {
    button: 'Open a ticket',
    description: 'Open a ticket whenever you need support.',
    icon: <IconTicket color={themeColors.secondaryBlue} size={40} />,
    id: 1,
    title: 'Create new tickets easily',
  },
  {
    button: 'Search articles',
    description: 'Easily find how-to articles and solutions.',
    icon: <IconListSearch color={themeColors.secondaryBlue} size={40} />,
    id: 2,
    title: 'Search troubleshooting articles',
  },
];

export const equipmentItem = {
  button: 'View equipment',
  description: 'Review equipment and open a ticket from the equipment screen.',
  icon: <IconListDetails color={themeColors.secondaryBlue} size={40} />,
  id: 3,
  title: 'Centralized equipment information',
};

export const ticketsItem = {
  button: 'View my tickets',
  description:
    'Chat with a support agent about updates and attach files easily.',
  icon: <IconMessageCircle color={themeColors.secondaryBlue} size={40} />,
  id: 4,
  title: 'Manage existing tickets',
};
